import ContactCard from './ContactCard';

export default ContactCard;



// WEBPACK FOOTER //
// ./src/components/ContactCard/index.js